import { usePreferenceStorage } from "@/setup/frontend/storage/PreferenceStorageContext";
import { trpc } from "@/common/utils/trpc";
import { useLogger } from "@/logging/client/LoggerContext";
import {
	ONBOARDING_PENDING_KEY,
	type OnboardingPendingPayload,
} from "./useOnboardingCompleted";

export function useSyncOfflineOnboarding() {
	const prefs = usePreferenceStorage();
	const utils = trpc.useUtils();
	const logger = useLogger();

	const sync = async () => {
		const raw = await prefs.getItem(ONBOARDING_PENDING_KEY);
		if (!raw) return;

		let payload: OnboardingPendingPayload;
		try {
			payload = JSON.parse(raw) as OnboardingPendingPayload;
		} catch {
			await prefs.removeItem(ONBOARDING_PENDING_KEY);
			return;
		}

		try {
			await utils.client.caregiverOnboardings.upsertOnboarding.mutate({
				notificationsPermission: payload.notificationsPermission,
				locationPermission: payload.locationPermission,
				microphonePermission: payload.microphonePermission,
				smsConsent: payload.smsConsent,
			});

			await prefs.removeItem(ONBOARDING_PENDING_KEY);
			logger.info("onboarding_synced_successfully");
		} catch (error) {
			logger.warn(
				`onboarding_sync_failed error=${error instanceof Error ? error.message : error}`,
			);
		}
	};

	return { sync };
}
